import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { msgAccessPromt } from "../../constant/constant";
import { login_user, signup_user } from "../../features/userSlice";
import { faArrowLeft, faCircleCheck, faCircleExclamation, faLock, faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NavImage from "../../resources/NavImage";
import LanguageSwitcher from "../../resources/LanguageSwitcher";
import { useT } from "../../i18n";

const PIN_LENGTH = 4;

// One row of 4 PIN boxes; typing moves forward, backspace moves back, paste fills the row
const PinRow = ({ id, label, values, onChange }) => {
    const { t } = useT();
    const focusBox = (index) => {
        const box = document.getElementById(`${id}-${index}`);
        if (box) box.focus();
    };

    const handleChange = (index, raw) => {
        const digits = raw.replace(/\D/g, "");
        const updated = [...values];
        if (!digits) {
            updated[index] = "";
            onChange(updated);
            return;
        }
        // Spread pasted / autofilled digits across the following boxes
        digits.slice(0, PIN_LENGTH - index).split("").forEach((d, i) => { updated[index + i] = d; });
        onChange(updated);
        focusBox(Math.min(index + digits.length, PIN_LENGTH - 1));
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !values[index] && index > 0) {
            e.preventDefault();
            const updated = [...values];
            updated[index - 1] = "";
            onChange(updated);
            focusBox(index - 1);
        }
    };

    return (
        <div className="pin-group">
            <label className="pin-label" htmlFor={`${id}-0`}>{label}</label>
            <div className="pin-boxes">
                {values.map((value, index) => (
                    <input
                        key={index}
                        id={`${id}-${index}`}
                        type="password"
                        inputMode="numeric"
                        autoComplete="new-password"
                        className={`pin-box${value ? " filled" : ""}`}
                        maxLength={PIN_LENGTH}
                        value={value}
                        aria-label={t('{label} digit {n}',{label,n:index + 1})}
                        onFocus={(e) => e.target.select()}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                    />
                ))}
            </div>
        </div>
    );
};

const MpinForm = () => {
    const [mpin, setMpin] = useState(["", "", "", ""]);
    const [confirmMpin, setConfirmMpin] = useState(["", "", "", ""]);
    const dispatch=useDispatch();
    const navigate = useNavigate();
    const { t } = useT();

    // This step needs the details from sign-up; send the user back if they skipped it
    useEffect(() => {
        if (!localStorage.getItem('phone_number') || !localStorage.getItem('user_name')) {
            navigate("/sign-up");
        }
    }, [navigate]);

    const mpinDone = mpin.every(Boolean);
    const confirmDone = confirmMpin.every(Boolean);
    const matches = mpinDone && confirmDone && mpin.join("") === confirmMpin.join("");

    const handleMpinChange = (values) => {
        setMpin(values);
        // Jump to the confirm row once the first PIN is complete
        if (values.every(Boolean) && !mpinDone) {
            const confirmFirst = document.getElementById("confirmMpin-0");
            if (confirmFirst) confirmFirst.focus();
        }
    };

    const handleSubmit = async (e) =>  {
        e.preventDefault();
         msgAccessPromt({dispatch,msg:'LOADING',error:true});
        if (JSON.stringify(mpin) === JSON.stringify(confirmMpin)) {
             let val='';
                    if(!(mpin[0] && mpin[1] && mpin[2] && mpin[3]))
                    {
                    msgAccessPromt({dispatch,error:true,msg:'Only 4 digit allow !!'});
                    return false;
                    }else{
                        val=mpin.reduce((acc, num) => parseInt(acc + num), 0);;
                    }
          var form_data_new = new FormData();
          let phone_number=localStorage.getItem('phone_number');
          let user_email=localStorage.getItem('user_email');
          let user_name=localStorage.getItem('user_name');
          let user_token=localStorage.getItem('user_token');

          form_data_new.append('phoneNumber',phone_number);
          form_data_new.append('username',user_name);
          form_data_new.append('token_id',user_token);
          form_data_new.append('user_mpin',val);
          form_data_new.append('email',user_email);

            try {
                // Create the account first, then log straight in with the new MPIN
                await dispatch(signup_user(form_data_new)).unwrap();
                let data = new FormData();
                data.append('phone_number',phone_number);
                data.append('password',val);
                data.append('token_id',user_token);
                await dispatch(login_user(data)).unwrap();
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_email');
            } catch (error) {
                console.error('API Error:', error);
                msgAccessPromt({dispatch,error:true,msg:error || 'Unable to create account. Please try again.'});
            }

        }else{
            msgAccessPromt({dispatch,error:true,msg:'Mpin does not match with confirm Mpin.'});
        }
      };

    let hint = <><FontAwesomeIcon icon={faShieldHalved} /> {t('Never share your MPIN with anyone.')}</>;
    let hintClass = "";
    if (confirmDone && matches) {
        hint = <><FontAwesomeIcon icon={faCircleCheck} /> {t('MPINs match')}</>;
        hintClass = " ok";
    } else if (confirmDone) {
        hint = <><FontAwesomeIcon icon={faCircleExclamation} /> {t("MPINs don't match. Try again.")}</>;
        hintClass = " error";
    }

    return (
        <div className="bodyDiv auth-page signup-page mpin-page">
            <LanguageSwitcher className="auth-lang" />
            <button type="button" className="pin-back" onClick={() => navigate(-1)} aria-label={t('Go back')}>
                <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <div className="auth-logo">
                <NavImage />
                <p className="brand-tagline">{t("Every Win, Securely Paid.")}</p>
            </div>
            <form className="signup-container pin-card" onSubmit={handleSubmit}>
                <div className="title_Form signup-heading" style={{justifyContent:'space-between'}}>
                    <div className="title_left">
                        <h1 className="main_title">{t("Create MPIN")}</h1>
                        <p>{t('Set a 4-digit PIN to log in quickly')}</p>
                    </div>
                    <div className="signup-icon-badge" aria-hidden="true">
                        <FontAwesomeIcon icon={faLock} />
                    </div>
                </div>
                <PinRow id="mpin" label={t("Enter MPIN")} values={mpin} onChange={handleMpinChange} />
                <PinRow id="confirmMpin" label={t("Confirm MPIN")} values={confirmMpin} onChange={setConfirmMpin} />
                <p className={`pin-hint${hintClass}`} role="status">{hint}</p>
                <button type="submit" className="continue-button" disabled={!matches}>{t('Create MPIN')}</button>
            </form>
        </div>
    );
};

export default MpinForm;
